// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import { Checkbox } from '@mui/material';
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import * as moment from 'moment';
import * as service from '../../services/service';

function SupplierWorkForApproval() {
    const [state, setState] = useState({ remarks: '', challanno: '' });
    const [data, setData] = useState([]);
    const [inspectionData, setInspectionData] = useState([]);
    const [observationData, setObservationData] = useState([]);
    const [remarksData, setRemarksData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [workAllocationIds, setWorkAllocationIds] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [operId, setOperId] = useState('');
    const [supplierId, setSupplierId] = useState('');
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    const getDetails = () => {
        fetch(
            service.GET_ORDERED_WORK_ALLOCATION_TO_SUPPLIER,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(result => {
                setData(result);
                result.forEach((element, index) => {
                    workAllocationIds[index] = element.workAllocationId;
                    setWorkAllocationIds([...workAllocationIds]);
                    isSelected[index] = false;
                    setIsSelected([...isSelected]);
                });
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const getInspectionParameters = () => {
        fetch(
            service.OPERATION_INSPECTION_PARAMETER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    OperationId: operId
                })
            })
            .then(res => res.json())
            .then(result => {
                setInspectionData(result);
                result.forEach((index) => {
                    observationData[index] = '0';
                    setObservationData([...observationData]);
                    remarksData[index] = '';
                    setRemarksData([...remarksData]);
                    statusData[index] = '';
                    setStatusData([...statusData]);
                });
            })
            .catch(err => {
                if (err) {
                    setError(err);
                };
            });
    };

    const handleCheckboxChange = (checked, index, opId, suppId) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);

        if (!supplierId) {
            setSupplierId(suppId);
        }
        else if (suppId !== supplierId) {
            // eslint-disable-next-line
            alert("Please select same Supplier");
        }

        if (!operId) {
            setOperId(opId);
        }
        else if (operId !== opId) {
            // eslint-disable-next-line
            alert("Please select same Operation");
        }
    }

    useEffect(() => {
        setLoading(true);
        setInspectionData([]);
        setObservationData([]);
        setRemarksData([]);
        setStatusData([]);
        getDetails();
        setLoading(false);
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".workAllocationIds"] = "Please select task";
        }
        setError(errs);
        return isValid;
    }

    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const observationChangeHandler = (event, upLimit, lowLimit, index) => {
        let updatedObject = observationData[index];
        updatedObject = event.target.value;
        observationData[index] = updatedObject;
        setObservationData([...observationData]);

        let statusObject = statusData[index];
        let st = '';
        if (event.target.value < lowLimit || event.target.value > upLimit) {
            st = 'Rejected';
            // setTaskStatus(false);
        }
        else {
            st = 'Approved';
        }
        statusObject = st;
        statusData[index] = statusObject;
        setStatusData([...statusData]);
    };

    const remarksChangeHandler = (event, index) => {
        let updatedObject = remarksData[index];
        updatedObject = event.target.value;
        remarksData[index] = updatedObject;
        setRemarksData([...remarksData]);
    };

    // Save inspection observations
    // const SaveInspectionObservations = () => {
    //     let flag = true;
    //     if (inspectionData) {
    //         inspectionData.forEach((element, index) => {
    //             fetch(
    //                 service.ADD_WORK_INSPECTION_OBSERVATION_OF_SUPPLIER,
    //                 {
    //                     method: 'POST',
    //                     headers: {
    //                         'Accept': 'application/json',
    //                         'Content-Type': 'application/json'
    //                     },
    //                     body: JSON.stringify({
    //                         WorkAllocationId: workAllocationId,
    //                         OperationInspParameterId: element.operationInspParameterId,
    //                         Observation: observationData[index],
    //                         Remakrs: remarksData[index],
    //                         Status: statusData[index],
    //                         AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
    //                     })
    //                 })
    //                 .then(res1 => res1.json())
    //                 .then(result => {
    //                     if (result.messageType === 'Success') {
    //                         flag = true;
    //                     }
    //                     else if (result.messageType === 'Failed') {
    //                         flag = false;
    //                     }
    //                     else {
    //                         flag = false;
    //                     }
    //                 });
    //         });
    //     }
    //     if (flag) {
    //         // eslint-disable-next-line
    //         alert("Data Saved Successfully");
    //         setWorkAllocationId('');
    //         setInspectionData([]);
    //         setObservationData([]);
    //         setRemarksData([]);
    //         setStatusData([]);
    //         window.location.reload(false);
    //     }
    //     else {
    //         // eslint-disable-next-line
    //         alert("Error.. Something Went Wrong");
    //     }
    // }

    const GetInspectionParameterHandler = () => {
        const errs = {};
        if (!isSelected.includes(true)) {
            errs[".workAllocationIds"] = "Please select task";
            setError(errs);
        }
        else {
            getInspectionParameters();
        }
    }

    // Save daily work status
    const submitHandler = (e) => {
        e.preventDefault();
        // const errs = {};
        if (validate()) {
            setLoading(true);
            let tskSt = true;
            let flag = true;
            statusData.forEach((element) => {
                if (element === "Rejected") {
                    tskSt = false;
                }
            });
            // eslint-disable-next-line
            if (window.confirm(`Do you want to save this/these task/s as ${tskSt ? 'Approved' : 'Rejected'}?`)) {
                workAllocationIds.forEach((element, index) => {
                    if (isSelected[index] === true) {
                        fetch(
                            service.UPDATE_WORK_ALLOCATION_TO_SUPPLIER_STATUS,
                            {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    WorkAllocationId: element,
                                    ChallanNo: state.challanno,
                                    Status: tskSt ? "Completed" : "Rejected",
                                    UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                })
                            })
                            .then(res => res.json())
                            .then(result => {
                                if (result.messageType === 'Success') {
                                    inspectionData.forEach((element1, index1) => {
                                        fetch(
                                            service.ADD_WORK_INSPECTION_OBSERVATION_OF_SUPPLIER,
                                            {
                                                method: 'POST',
                                                headers: {
                                                    'Accept': 'application/json',
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify({
                                                    WorkAllocationId: element,
                                                    OperationInspParameterId: element1.operationInspParameterId,
                                                    Observation: observationData[index1],
                                                    Remakrs: remarksData[index1],
                                                    Status: statusData[index1],
                                                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                                })
                                            })
                                            .then(res1 => res1.json())
                                            .then(result1 => {
                                                if (result1.messageType === 'Failed') {
                                                    // eslint-disable-next-line
                                                    alert(result1.message);
                                                }
                                            });
                                    });
                                }
                                else if (result.messageType === 'Failed') {
                                    // eslint-disable-next-line
                                    alert(result.message);
                                    flag = false;
                                }
                            });
                    }
                });
                if (flag) {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        alert("Data Saved Successfully");
                        setWorkAllocationIds([]);
                        setIsSelected([]);
                        getDetails();
                        // setInspectionData([]);
                        // setObservationData([]);
                        // setRemarksData([]);
                        // setStatusData([]);
                        // window.location.reload(false);                        
                    }, 60000);
                }
                else {
                    // eslint-disable-next-line
                    alert("Error.. Something Went Wrong");
                }
            }
            setLoading(false);
        }
    };

    // Save supplier work status
    const nonWorkableHandler = (e) => {
        e.preventDefault();
        // const errs = {};
        if (validate()) {
            setLoading(true);
            let flag = true;
            // eslint-disable-next-line
            if (window.confirm(`Do you want to save this/these task/s as Non Workable?`)) {
                workAllocationIds.forEach((element, index) => {
                    if (isSelected[index] === true) {
                        fetch(
                            service.UPDATE_WORK_ALLOCATION_TO_SUPPLIER_STATUS,
                            {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    WorkAllocationId: element,
                                    Status: 'Non Workable',
                                    UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                })
                            })
                            .then(res => res.json())
                            .then(result => {
                                if (result.message.messageType === 'Failed') {
                                    // eslint-disable-next-line
                                    alert(result.message);
                                    flag = false;
                                }
                            });
                    }
                });

                if (flag) {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        alert("Data Saved Successfully");
                        setWorkAllocationIds([]);
                        setIsSelected([]);
                        setInspectionData([]);
                        setObservationData([]);
                        setRemarksData([]);
                        setStatusData([]);
                        window.location.reload(false);
                    }, 60000);
                }
                else {
                    // eslint-disable-next-line
                    alert("Error.. Something Went Wrong");
                }
            }
            setLoading(false);
        }
    };

    const clearHandler = () => {
        setWorkAllocationIds([]);
        setInspectionData([]);
        setObservationData([]);
        setRemarksData([]);
        setStatusData([]);
        setIsSelected([]);
        setState({ ...state, challanno: '' });
        getDetails();
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Work Details For Approval
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                        <div align='center' style={{ fontSize: '14px', color: 'red' }}>Please Select Same Supplier and Same Operations of Product/Sub Assembly/Part</div>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Allocation For</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Sub Assembly</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Part</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Common Part</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Stock No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Operation</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Supplier</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Allocated Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Planned Completion Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.workAllocationId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell><Checkbox checked={isSelected[index] || false}
                                                            onChange={(e) =>
                                                                handleCheckboxChange(e.target.checked, index, row.operationId, row.supplierId)} id="chkSelect" />
                                                        </TableCell>
                                                        <TableCell>{row.allocationFor}</TableCell>
                                                        <TableCell>{row.product}</TableCell>
                                                        <TableCell>{row.subAssembly}</TableCell>
                                                        <TableCell>{row.part}</TableCell>
                                                        <TableCell>{row.commonPart}</TableCell>
                                                        <TableCell>{row.stockNo}</TableCell>
                                                        <TableCell>{row.operation}</TableCell>
                                                        <TableCell>{row.supplierName}</TableCell>
                                                        <TableCell>{moment(row.allocationDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{moment(row.plannedCompletionDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{row.remarks}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Table>
                                            <TableRow>
                                                <TableCell colSpan="13" align='center'>
                                                    <MDButton color="info" onClick={GetInspectionParameterHandler}>
                                                        Get Inspection Parameters
                                                    </MDButton>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                        <div style={{ fontSize: '12px', color: 'red' }}>{error[".workAllocationIds"]}</div>
                                    </TableContainer>
                                }
                            </Card>
                            <br />
                            <MDTypography variant="h6" color="white">
                                Inspection Parameters
                            </MDTypography>
                            <Card style={{ alignItems: 'center' }}>
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '70%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Inspection Parameter</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Specification</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Upper Limit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Lower Limit</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Observation(In Decimal)</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {inspectionData.map((row, index) => (
                                                    <TableRow
                                                        key={row.operationInspParameterId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.inspectionParameter}</TableCell>
                                                        <TableCell>{row.specification}</TableCell>
                                                        <TableCell>{row.upperLimit}</TableCell>
                                                        <TableCell>{row.lowerLimit}</TableCell>
                                                        <TableCell>
                                                            <MDInput label="Observation" fullWidth
                                                                name="observation"
                                                                onChange={ev => observationChangeHandler(ev, row.upperLimit, row.lowerLimit, index)}
                                                                id="observation"
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDInput label="Remarks" fullWidth
                                                                name="remarks"
                                                                onChange={ev => remarksChangeHandler(ev, index)}
                                                                id="remarks"
                                                                multiline
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Card>
                            <br />
                            <Card style={{ alignItems: 'center' }}>
                                <TableContainer component={Paper} style={{ width: '50%', alignSelf: 'center', }}>
                                    <Table aria-label="simple table">
                                        <TableRow>
                                            <TableCell colSpan={2}>
                                                <MDInput label="Challan No" fullWidth value={state.challanno || ''}
                                                    name="challanno"
                                                    onChange={changeHandler}
                                                    id="challanno"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{error[".challanno"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        {userDesignation === 'General Manager' || userDesignation === 'Manager - Production'
                                            || userDesignation === 'Sr Mgr - Production' || userDesignation === 'MD' || userDesignation === 'Asst Mgr - Production' ?
                                            <TableRow>
                                                <TableCell>
                                                    <MDBox mt={4} mb={1} textAlign="center">
                                                        {loading ? <Oval
                                                            heigth="20"
                                                            width="20"
                                                            color='grey'
                                                            ariaLabel='loading'
                                                        /> :
                                                            <div>
                                                                <div align='center' style={{ fontSize: '14px', color: 'red' }}>Please wait for 1 min for large data to be saved</div>
                                                                <MDButton color="info" onClick={submitHandler}>
                                                                    Save Approved/Rejected
                                                                </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <MDButton color="info" onClick={nonWorkableHandler}>
                                                                    Save Non Workable
                                                                </MDButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <MDButton color="info" onClick={clearHandler}>
                                                                    Clear
                                                                </MDButton>
                                                            </div>
                                                        }
                                                        {error ? <div style={{ fontSize: '12px', color: 'red' }}>{error[".invalid"]}</div> : null}
                                                    </MDBox>
                                                </TableCell>
                                            </TableRow>
                                            : null}
                                    </Table>
                                </TableContainer>
                            </Card>

                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default SupplierWorkForApproval;